module.exports = __webpack_public_path__ + "img/casana-page-layout.4c784bbe.jpg";